import React from "react";
import { OpenDataGroupFieldsItemsFieldsFields } from "./OpenDataGroupPageContent";
import Image from "next/image";
import { extractRelativePath, CleanRelativeLink } from "components/Shared/DomainSplit";
import { getDgAButtonClassNames } from "components/Shared/dga-button/DGAButton";
import IsRtl from "components/Shared/isRtl";

type OpenDataGroupItemProps = OpenDataGroupFieldsItemsFieldsFields & {
  url?: string;
};

// Remove the last segment from URL to redirect to parent page
const getParentUrl = (url: string): string => {
  if (!url) return "";
  const urlParts = url.split("/").filter(Boolean);
  if (urlParts.length > 1) {
    urlParts.pop(); // Remove last segment
    return "/" + urlParts.join("/");
  }
  return url;
};

export const OpenDataGroupItem: React.FunctionComponent<OpenDataGroupItemProps> = ({
  Icon,
  Title,
  url,
}) => {
  return (
    <div className="p-4 items-start justify-between flex flex-col gap-6 rounded-2xl border border-neutral-300 animate-top-dga ">
      {Icon?.value?.src && (
        <div className="relative rounded-full w-[48px] h-[48px]">
          <Image
            src={extractRelativePath(Icon?.value?.src)}
            alt={Icon?.value?.alt?.trim() || "Open data group icon"}
            layout="fill"
            className="w-full h-full object-contain"
          />
        </div>
      )}
      {Title?.value && <p className="font-bold text-lg">{Title?.value}</p>}
      {url && (
        <div className="flex flex-row gap-4 items-end justify-end w-full">
          <a
            href={CleanRelativeLink(getParentUrl(url))}
            onClick={(e: any) => e.stopPropagation()}
            className={`w-fit inline-flex items-center justify-center ${getDgAButtonClassNames(
              "secondarySolid",
              "iconOnly lg"
            )}`}
            aria-label="View details"
          >
            <img
              src="/Icons/arrow-right.svg"
              alt=""
              className={`w-5 h-5 ${IsRtl() ? "rotate-180" : ""}`}
              aria-hidden="true"
            />
          </a>
        </div>
      )}
    </div>
  );
};
